module.exports = __webpack_public_path__ + "static/media/VitalIcon.cbf0b748.svg";